import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

// Goals API
export const getGoals = async (year) => {
  const response = await api.get(`/goals/${year}`);
  return response.data;
};

export const saveGoals = async (goals) => {
  const response = await api.post("/goals", goals);
  return response.data;
};

export const getAllGoals = async () => {
  const response = await api.get("/goals");
  return response.data;
};

// Monthly Stats API
export const getMonthlyStats = async (year, month) => {
  const response = await api.get(`/stats/${year}/${month}`);
  return response.data;
};

export const saveMonthlyStats = async (stats) => {
  const response = await api.post("/stats", stats);
  return response.data;
};

export const getAllStats = async (year) => {
  const response = await api.get("/stats", { params: year ? { year } : {} });
  return response.data;
};

// Dashboard API
export const getDashboard = async (year) => {
  const response = await api.get(`/dashboard/${year}`);
  return response.data;
};

// Reports API
export const getQuarterlyReport = async (year, quarter) => {
  const response = await api.get(`/reports/quarterly/${year}/${quarter}`);
  return response.data;
};

export const getYtdReport = async (year) => {
  const response = await api.get(`/reports/ytd/${year}`);
  return response.data;
};

// Import/Export API
export const importData = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post("/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const exportData = async (year) => {
  const response = await api.get(`/export/${year}`, { responseType: "blob" });
  return response.data;
};

export const downloadTemplate = async () => {
  const response = await api.get("/import/template", { responseType: "blob" });
  return response.data;
};

// Helper to get month name
export const getMonthName = (month) => {
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  return months[month - 1] || "";
};

// Helper to get quarter label
export const getQuarterLabel = (quarter) => {
  const quarters = ["1st Quarter", "2nd Quarter", "3rd Quarter", "4th Quarter"];
  return quarters[quarter - 1] || "";
};

export default api;
